export default __webpack_public_path__ + "static/media/myc_pools_switch.e6bd0676.svg";